import React from 'react';
import { NavLink } from 'react-router-dom';

const AddFundCrumb = () => <NavLink to="/core/funds/add">Add Fund</NavLink>;

export default AddFundCrumb;
